import React from 'react';
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import {applyMiddleware, combineReducers, createStore} from 'redux'
import createSagaMiddleware from 'redux-saga'
import tours from './app/tours/reducers'
import toursSagas from './app/tours/sagas';
import clinics from './app/clinics/reducers'
import clinicsSagas from './app/clinics/sagas';
import tandems from './app/tandems/reducers'
import tandemsSagas from './app/tandems/sagas';
import payments from './app/payments/reducers'
import paymentsSagas from './app/payments/sagas';
import contact from './app/contact/reducers'
import contactSagas from './app/contact/sagas';
import Application from './app/Application';
import registerServiceWorker from './registerServiceWorker';
import './toolbox/theme.css'
import './index.css';

const sagas = createSagaMiddleware();

const store = createStore(
    combineReducers({tours, clinics, tandems, payments, contact}),
    applyMiddleware(sagas)
);

[toursSagas, clinicsSagas, tandemsSagas, paymentsSagas, contactSagas].forEach(s => sagas.run(s));

render(
    <Provider store={store}>
        <Application/>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js